<template>
  <ion-page>
    <!-- Loader -->
     

    <KiwishLoader v-if="loading" :is-open="loading" :message="$t('loading')" />

    <!-- Error con retry -->
    <div v-else-if="dataStore.error" class="error-fullscreen">
      <ErrorRetry :message="dataStore.error" @retry="handleRetry" />
    </div>

    <!-- Contenido principal -->
    <template v-else>
      <KiwishMenu />

      <!--
        IMPORTANTE: Solo un router-outlet debe estar activo a la vez
        para evitar problemas de renderizado duplicado en iOS WebKit
      -->

      <!-- Router outlet SIN tabs (web o no logueado) -->
      <ion-router-outlet
        v-if="!isHybrid || !isLoggedIn"
        id="main-content"
        :animated="false"
        v-show="!showNewMatch && !showNewFan"
      ></ion-router-outlet>

      <!-- MODAL NEW FAN -->
      <div v-if="showNewFan" class="overlay-modal">
        <NewFan :fan="newFanData" :fans="dataStore.fans" @done="hideNewFan" @markAsRead="markFanAsRead" />
      </div>

      <!-- MODAL NEW MATCH -->
      <div v-if="showNewMatch" class="overlay-modal">
        <NewMatch @done="hideNewMatch" />
      </div>

      <!-- Tabs inferiores CON router-outlet (solo nativo/híbrido y logueado) -->
      <ion-tabs v-if="isHybrid && isLoggedIn">
        <ion-router-outlet :animated="false" v-show="!showNewMatch && !showNewFan"></ion-router-outlet>
        <ion-tab-bar slot="bottom">

          <ion-tab-button tab="matchs" href="/app/matchs" @click="checkTimeBasedReload">
            <div class="tab-icon-circle">
              <svg viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.12975 0.0543952C3.98026 0.117776 3.56019 0.531284 2.98354 1.18258C1.20979 3.18597 0.333293 4.89827 0.0549857 6.90361C-0.0266512 7.4919 -0.0153079 8.80336 0.0752264 9.24674C0.227663 9.99305 0.527266 10.6916 0.980739 11.3578C1.28047 11.7982 1.95671 12.4535 2.42229 12.7546C2.77848 12.9851 3.5036 13.3472 3.53936 13.3126C3.54965 13.3026 3.38578 13.1576 3.17528 12.9902C2.71384 12.6234 1.97522 11.8911 1.67959 11.5074C0.628595 10.1431 0.379467 8.85379 0.95042 7.73378C1.50404 6.64776 2.79754 6.02568 4.00324 6.26551C4.42117 6.34867 4.93946 6.5845 5.25972 6.83733L5.50265 7.02907L5.70172 6.86794C5.98328 6.64004 6.30342 6.46714 6.67584 6.34189C6.95162 6.24913 7.06885 6.23348 7.50318 6.23156C7.91908 6.22976 8.06553 6.24631 8.32545 6.32465C8.8135 6.47168 9.1497 6.67248 9.53187 7.04529C10.1239 7.62279 10.3804 8.27564 10.3351 9.08987C10.3084 9.57076 10.2265 9.9009 10.0154 10.3781C9.63699 11.2332 8.74827 12.2757 7.70221 13.0912C7.53337 13.2228 7.40286 13.3379 7.41222 13.347C7.44266 13.3765 7.9806 13.1635 8.37807 12.9646C9.72711 12.2893 10.6672 11.0424 10.9448 9.55981C11.0174 9.17221 11.0187 7.67935 10.9469 7.16923C10.706 5.45705 10.1686 4.09352 8.96859 2.14968C8.63939 1.61636 8.53726 1.53925 8.18899 1.56091C8.00443 1.57235 7.9211 1.59952 7.83744 1.67553C7.5499 1.93666 7.17874 2.82297 7.07787 3.48926C7.04363 3.7152 7.01091 3.91552 7.00513 3.9344C6.98961 3.98507 6.405 3.21249 6.10118 2.73985C5.77008 2.22471 5.3597 1.43513 5.08131 0.777452C4.9632 0.49847 4.8431 0.242699 4.81438 0.209108C4.74721 0.130403 4.44968 -0.000894426 4.34059 4.5927e-06C4.2942 0.000413238 4.19933 0.0248502 4.12975 0.0543952ZM3.98494 2.08303C4.10525 2.14543 4.08433 2.28462 3.93173 2.4372C3.78992 2.579 3.69512 2.60438 3.61108 2.52294C3.52751 2.44195 3.55281 2.35086 3.70322 2.19173C3.86068 2.02517 3.86793 2.02235 3.98494 2.08303ZM3.42555 2.78447C3.51654 2.87266 3.47935 2.98683 3.27024 3.26169C2.68289 4.03354 2.2596 4.79488 1.99934 5.54748C1.83008 6.03704 1.76637 6.12098 1.62131 6.04575C1.5107 5.98837 1.51416 5.91367 1.64615 5.50874C1.88452 4.77743 2.28069 4.03656 2.84848 3.26018C3.24772 2.71427 3.30465 2.66731 3.42555 2.78447ZM3.05447 6.57792C2.23468 6.74383 1.5764 7.22808 1.23666 7.91517C0.423659 9.55936 1.69169 11.7146 4.57251 13.5851C5.41009 14.1289 5.58108 14.133 6.36464 13.6275C9.29219 11.7389 10.5824 9.5708 9.76388 7.91542C9.41916 7.21827 8.73186 6.71809 7.92764 6.57907C7.16554 6.44736 6.39602 6.68842 5.81461 7.24099L5.5002 7.53979L5.19158 7.24647C4.72495 6.80301 4.2334 6.59251 3.58292 6.55765C3.39662 6.54768 3.15883 6.5568 3.05447 6.57792ZM2.46264 8.86241C2.57026 9.0573 2.47635 9.25181 2.28722 9.22582C2.20504 9.2145 2.18796 9.18467 2.17674 9.03261C2.16308 8.84721 2.20546 8.78522 2.34668 8.78399C2.38645 8.78367 2.43861 8.81893 2.46264 8.86241ZM2.69313 9.78411C2.81664 10.0706 3.15002 10.5146 3.51945 10.8847C3.72755 11.0931 3.89783 11.2918 3.89783 11.3262C3.89783 11.4226 3.78372 11.4923 3.67092 11.4649C3.40134 11.3993 2.33762 10.0663 2.33762 9.79408C2.33762 9.71113 2.42777 9.64154 2.53526 9.64154C2.60551 9.64154 2.64831 9.68019 2.69313 9.78411Z" fill="#5A695B"/>
              </svg>
            </div>
            <ion-label>{{ $t('tabs.matchs.title') }}</ion-label>
          </ion-tab-button>

          <ion-tab-button tab="fans" href="/app/fans" @click="onFansTabClick">
            <div class="tab-icon-circle">
              <svg viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.575375 0.0521969C0.349173 0.15113 0.240696 0.254294 0.113623 0.491467C0.0148867 0.675705 0.00770411 0.76352 0.000915085 1.86895C-0.00779258 3.28456 0.044552 3.99411 0.20493 4.63612C0.440136 5.57753 1.06591 6.56292 1.89156 7.29206C2.43837 7.77491 2.53411 7.88319 2.69296 8.19785C2.83661 8.48235 2.99881 9.01868 3.05928 9.40886C3.0793 9.53809 3.12657 9.63722 3.18246 9.66714C3.32523 9.74354 6.63429 9.73148 6.73755 9.6542C6.80918 9.60057 6.82055 9.46376 6.8266 8.58419C6.8325 7.71982 6.81902 7.51541 6.73229 7.15416C6.46255 6.03072 5.55488 4.3373 4.57367 3.12704C4.16643 2.6247 3.90638 2.46166 3.58075 2.50456C3.10021 2.56788 2.83691 2.89582 2.83691 3.43102C2.83691 3.87034 3.05716 4.30341 3.55635 4.8455C3.87824 5.19508 3.91956 5.25938 3.84793 5.29943C3.64653 5.41214 3.23003 5.1602 2.9018 4.72708C2.41397 4.08345 1.98744 2.95923 1.73286 1.64624C1.66221 1.2817 1.58197 0.872833 1.55457 0.737692C1.44226 0.183353 0.993688 -0.130664 0.575375 0.0521969ZM12.9894 0.0296656C12.7486 0.0975559 12.4977 0.410785 12.4363 0.720129C12.4076 0.864962 12.3261 1.2817 12.2553 1.64624C11.9264 3.33937 11.309 4.71021 10.6807 5.14249C10.444 5.30533 10.1515 5.38218 10.098 5.29559C10.0801 5.26671 10.2322 5.06201 10.436 4.84068C10.9306 4.30365 11.151 3.86896 11.151 3.43102C11.151 2.86236 10.8416 2.51199 10.3393 2.51199C9.98896 2.51199 9.79449 2.64915 9.35389 3.20708C8.36249 4.46236 7.52257 6.04238 7.25563 7.15416C7.1689 7.51541 7.15542 7.71982 7.16132 8.58419C7.16738 9.46376 7.17874 9.60057 7.25037 9.6542C7.35363 9.73148 10.6627 9.74354 10.8055 9.66714C10.8613 9.63722 10.9086 9.53809 10.9286 9.40886C10.9891 9.01868 11.1513 8.48235 11.295 8.19785C11.4537 7.88334 11.5413 7.78475 12.1217 7.26746C12.9539 6.52578 13.545 5.5886 13.7841 4.63159C13.9385 4.0136 14.0198 2.85666 13.9959 1.61682C13.9772 0.648844 13.9508 0.520394 13.7157 0.252768C13.5456 0.0591825 13.2293 -0.0379787 12.9894 0.0296656Z" fill="#FF5287"/>
              </svg>
            </div>
            <ion-label>{{ $t('tabs.fans.title') }}</ion-label>
          </ion-tab-button>

          <ion-tab-button tab="secrets" href="/app/secrets" @click="checkTimeBasedReload">
            <div class="tab-icon-circle">
              <svg viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.404654 7.42328C0.245569 7.49285 0.169278 7.56541 0.0799095 7.73221C0.0104697 7.86178 0.00541821 7.92354 0.000643568 8.70098C-0.00548043 9.69656 0.0313328 10.1956 0.144125 10.6471C0.309542 11.3092 0.749639 12.0022 1.33031 12.515C1.71488 12.8546 1.78221 12.9307 1.89393 13.152C1.99496 13.3521 2.10903 13.7293 2.15155 14.0037C2.16563 14.0946 2.19888 14.1643 2.23819 14.1853C2.33859 14.2391 4.66581 14.2306 4.73844 14.1762C4.78881 14.1385 4.7968 14.0423 4.80106 13.4237C4.80521 12.8158 4.79573 12.6721 4.73473 12.418C4.54503 11.6279 3.90668 10.4369 3.21661 9.58577C2.9302 9.23248 2.74731 9.11782 2.5183 9.14799C2.18034 9.19252 1.99516 9.42316 1.99516 9.79956C1.99516 10.1085 2.15006 10.4131 2.50114 10.7943C2.72752 11.0402 2.75658 11.0854 2.7062 11.1136C2.56456 11.1929 2.27164 11.0157 2.0408 10.7111C1.69772 10.2584 1.39774 9.46776 1.2187 8.54435C1.16901 8.28797 1.11258 8.00042 1.09331 7.90538C1.01432 7.51552 0.698848 7.29467 0.404654 7.42328ZM9.13526 7.40743C8.96596 7.45518 8.78951 7.67547 8.7463 7.89302C8.72609 7.99488 8.66879 8.28797 8.61901 8.54435C8.38768 9.7351 7.9535 10.6992 7.5116 11.0032C7.34515 11.1177 7.13939 11.1718 7.10178 11.1109C7.08922 11.0906 7.1962 10.9466 7.33954 10.791C7.68733 10.4133 7.84237 10.1076 7.84237 9.79956C7.84237 9.39963 7.62474 9.15322 7.27149 9.15322C7.02511 9.15322 6.88834 9.24968 6.57847 9.64206C5.88124 10.5249 5.29053 11.6361 5.1028 12.418C5.0418 12.6721 5.03232 12.8158 5.03647 13.4237C5.04073 14.0423 5.04872 14.1385 5.09909 14.1762C5.17172 14.2306 7.49894 14.2391 7.59934 14.1853C7.63865 14.1643 7.6719 14.0946 7.68598 14.0037C7.7285 13.7293 7.84257 13.3521 7.9436 13.152C8.05525 12.9308 8.11687 12.8615 8.52504 12.4977C9.11031 11.9761 9.52602 11.317 9.6942 10.6439C9.80281 10.2093 9.85996 9.39562 9.84311 8.52366C9.82997 7.84289 9.81142 7.75255 9.64607 7.56433C9.52646 7.42819 9.30403 7.35986 9.13526 7.40743Z" fill="#5A695B"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.2915 8.19978C3.87257 8.08712 3.49593 7.78615 3.2981 7.40591C3.13998 7.10206 3.10116 6.91855 3.11725 6.5517C3.12922 6.27913 3.14839 6.19415 3.24384 5.9903C3.39241 5.67296 3.5624 5.47156 3.81836 5.30956C3.93388 5.23646 4.04785 5.16017 4.07162 5.14C4.10542 5.11131 4.11487 4.59354 4.11487 2.76755C4.11487 0.208242 4.10529 0.329165 4.32281 0.146138C4.53365 -0.0312854 4.8328 -0.0488617 5.058 0.102889C5.19048 0.192189 5.32448 0.415144 5.32527 0.547657L5.32583 0.642804L5.77672 0.642804C6.25709 0.642804 6.40642 0.677507 6.56554 0.826109C6.69297 0.945059 6.74438 1.07356 6.74424 1.2725C6.7441 1.48857 6.67113 1.62752 6.48202 1.7719C6.35452 1.86926 6.34283 1.87127 5.839 1.8822L5.32583 1.89334L5.32583 1.99465L5.32583 2.09596L5.81886 2.09651C6.26602 2.09703 6.3247 2.10436 6.4496 2.17508C6.81908 2.38434 6.84396 2.95947 6.49434 3.20886C6.3896 3.28353 6.34134 3.29045 5.85346 3.30069L5.32583 3.31179L5.32583 4.22292L5.32583 5.13404L5.50747 5.23698C5.73403 5.36534 6.04832 5.69347 6.15271 5.91068C6.38583 6.39579 6.38549 6.898 6.15174 7.37795C6.03773 7.61201 5.66362 7.97976 5.42575 8.09159C5.06603 8.26067 4.66146 8.29928 4.2915 8.19978ZM5.0069 7.33584C5.28438 7.21994 5.4627 6.94993 5.4627 6.6457C5.4627 6.07586 4.85736 5.71935 4.35454 5.99303C3.82009 6.2839 3.83953 7.03061 4.38913 7.32117C4.54234 7.40217 4.83165 7.40906 5.0069 7.33584Z" fill="#5A695B"/>
              </svg>
            </div>
            <ion-label>{{ $t('tabs.secrets.title') }}</ion-label>
          </ion-tab-button>

          <ion-tab-button tab="account" href="/app/account" @click="checkTimeBasedReload">
            <div class="tab-icon-circle">
              <font-awesome-icon :icon="['fas', 'user']" />
            </div>
            <ion-label>{{ $t('tabs.account.title') }}</ion-label>
          </ion-tab-button>

        </ion-tab-bar>
      </ion-tabs>
    </template>

    <!-- ALERTA ESTILO KIWISH -->
    <div v-if="showDeniedAlert" class="overlay-modal">
      <div class="kiwish-alert-box">
        <h2 class="title">{{ $t('notifications.alert.title') }}</h2>
        <p class="text">{{ $t('notifications.alert') }}</p>

        <button class="btn-accept" @click="showDeniedAlert = false">
          {{ $t('ok') }}
        </button>
      </div>
    </div>

    <!-- MODAL PERMISOS NOTIFICACIONES -->
    <div v-if="showNotificationsModal" class="overlay-modal">
      <div class="notifications-box">
        <h2 class="title">{{ $t('notifications.title') }}</h2>
        <p class="text">{{ $t('notifications.description') }}</p>

        <button class="btn-accept" @click="enableNotifications">
          {{ $t('notifications.enable') }}
        </button>

        <button class="btn-later" @click="closeNotificationsModal">
          {{ $t('notifications.later') }}
        </button>

        <button class="btn-later" @click="disableNotificationsForever">
          {{ $t('notifications.disable') }}
        </button>
      </div>
    </div>    
  </ion-page>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useTabsStore } from '@/store/tabs'
import { useDataStore } from '@/store/data'
import NewMatch from '@/views/components/secrets/NewMatch.vue'
import axios from '@/plugins/axios.js'
import { useRoute, useRouter } from 'vue-router'
import KiwishMenu from '@/views/components/KiwishMenu.vue'
import { getLocalData, setLocalData } from '@/utils/localdata';
import { changeLanguage } from '@/plugins/i18n/index'
import NewFan from '@/views/components/fans/NewFan.vue'
import { shouldAskForNotifications, initPush, reRegisterPushIfNeeded, setBadge } from '@/services/notifications';
import KiwishLoader from '@/views/components/KiwishLoader.vue'
import ErrorRetry from '@/views/components/ErrorRetry.vue'

const route = useRoute()
const router = useRouter()
const tabsStore = useTabsStore()
const dataStore = useDataStore()
const loading = ref(true)
const isHybrid = dataStore.isHybrid
const isLoggedIn = ref(false)
const lang = ref()
const showNewMatch = ref(false)
const showNewFan = ref(false)
const showNotificationsModal = ref(false);

// Computed para obtener el primer fan nuevo
const newFanData = computed(() => {
  return dataStore.fans?.find(f => f.new) || null;
});
const showDeniedAlert = ref(false);

const checkNotifications = async () => {
  if (!isHybrid) return;

  // Si el usuario ha dicho "no me preguntes más", salimos
  const optOut = await getLocalData('notifications_opt_out');
  if (optOut === '1') return;

  const ask = await shouldAskForNotifications();

  if (ask === "ask") {
    showNotificationsModal.value = true;
  }

  if (ask === "denied") {
    showDeniedAlert.value = true;
  }

  // Si ya tiene permisos, inicializamos push notifications automáticamente
  if (ask === "granted") {
    await initPush();
  }
};

let appStateListener = null;
let lastDataReload = Date.now();

// Función para recargar datos cuando llega una notificación push
const handlePushNotification = async (event) => {
  const authToken = await getLocalData('authToken');
  if (authToken && authToken !== 'null' && authToken !== 'undefined') {
    await dataStore.loadData();
    await checkForNewItems();
    lastDataReload = Date.now();
  }
};

// Verificar si es necesario recargar por tiempo transcurrido
const checkTimeBasedReload = async () => {
  const authToken = await getLocalData('authToken');
  if (!authToken || authToken === 'null' || authToken === 'undefined') {
    return;
  }

  const timeSinceLastReload = Date.now() - lastDataReload;
  const RELOAD_THRESHOLD = 30000; // 30 segundos

  if (timeSinceLastReload > RELOAD_THRESHOLD) {
    await dataStore.loadData();
    await checkForNewItems();
    lastDataReload = Date.now();
  }
};

onMounted(async () => {
  // Verificar si el usuario está autenticado
  const authToken = await getLocalData('authToken');
  isLoggedIn.value = !!(authToken && authToken !== 'null' && authToken !== 'undefined');

  // Solo cargar datos si el usuario está autenticado
  if (isLoggedIn.value) {
    await dataStore.loadData()
    lastDataReload = Date.now();
    await checkForNewItems()

    // Si es la primera visita y no tiene fans, matchs ni secrets, llevar al wizard de secrets
    const hasVisitedApp = await getLocalData('app_visited');
    if (!hasVisitedApp) {
      await setLocalData('app_visited', '1');
      const hasFans = dataStore.fans && dataStore.fans.length > 0;
      const hasMatchs = dataStore.matchs && dataStore.matchs.length > 0;
      const hasSecrets = dataStore.secrets && dataStore.secrets.length > 0;

      if (!hasFans && !hasMatchs && !hasSecrets) {
        // Usar setTimeout para evitar conflictos con el renderizado
        setTimeout(() => {
          router.replace('/app/secrets/new?first=true');
        }, 0);
      }
    }
  }

  // Quitar el loader inmediatamente después de cargar datos (o si hay error)
  // para que se muestre ErrorRetry si corresponde
  loading.value = false

  lang.value = await getLocalData('lang')
  changeLanguage(lang.value || 'es');

  // Escuchar evento de notificaciones push para recargar datos
  window.addEventListener('reloadAppData', handlePushNotification);

  if (isHybrid){
    checkNotifications();

    // Detectar cuando la app vuelve a primer plano (ej: volver de Ajustes)
    try {
      const { App } = await import('@capacitor/app');
      appStateListener = await App.addListener('appStateChange', async ({ isActive }) => {
        if (isActive) {
          await reRegisterPushIfNeeded();
          // Recargar datos basado en tiempo transcurrido
          await checkTimeBasedReload();
        }
      });
    } catch (error) {
      // Capacitor App not available (web mode)
    }
  }

  // Polling para recargar datos cada 60 segundos (funciona mejor en web)
  setInterval(async () => {
    const authToken = await getLocalData('authToken');
    if (authToken && authToken !== 'null' && authToken !== 'undefined') {
      await dataStore.loadData()
      await checkForNewItems()
      lastDataReload = Date.now();
    }
  }, 60000)
})

onUnmounted(() => {
  // Limpiar listener cuando el componente se desmonta
  if (appStateListener) {
    appStateListener.remove();
  }
  // Limpiar listener de notificaciones push
  window.removeEventListener('reloadAppData', handlePushNotification);
})

const checkForNewItems = async () => {
  const hasNewMatches = dataStore.matchs?.some(m => m.new);
  const hasNewFans = dataStore.fans?.some(f => f.new);

  if (hasNewMatches) {
    showNewMatch.value = true;
  }

  if (hasNewFans) {
    showNewFan.value = true;
  }

  // Actualizar badge con el total de nuevos items
  if (isHybrid) {
    const newMatchCount = dataStore.matchs?.filter(m => m.new).length || 0;
    const newFanCount = dataStore.fans?.filter(f => f.new).length || 0;
    const totalNew = newMatchCount + newFanCount;
    await setBadge(totalNew);
  }
}

const hideNewMatch = async () => {
  showNewMatch.value = false;
  axios.post('/secrets/no-newmatch').catch(() => {});

  // Actualizar badge después de ocultar el modal
  if (isHybrid) {
    await dataStore.loadData();
    await checkForNewItems();
  }
}

const hideNewFan = async () => {
  showNewFan.value = false;

  // Actualizar badge después de ocultar el modal
  if (isHybrid) {
    await dataStore.loadData();
    await checkForNewItems();
  }
}

const markFanAsRead = (fan) => {
  if (fan) {
    fan.new = 0;
  }
}

const onFansTabClick = async () => {
  if (route.fullPath === '/app/fans') {
    tabsStore.forceCloseNewFanModal = true;
  }
  // Verificar si es necesario recargar por tiempo transcurrido
  await checkTimeBasedReload();
}

const enableNotifications = async () => {
  showNotificationsModal.value = false;
  await initPush();
};

const closeNotificationsModal = () => {
  showNotificationsModal.value = false;
};

const disableNotificationsForever = () => {
  setLocalData('notifications_opt_out', '1');
  showNotificationsModal.value = false;
};

const handleRetry = async () => {
  loading.value = true;
  await dataStore.retry();
  loading.value = false;
};

</script>

<style>
/*
 * Desactivar animaciones de transición de página de Ionic
 * IMPORTANTE: Solo desactivamos transiciones de página, NO todas las propiedades
 * Para que iOS WebKit pueda repintar correctamente el contenido
 */

/* Desactivar solo las transiciones de página de Ionic */
ion-router-outlet {
  --ion-page-transition-duration: 0ms !important;
}

/* Ocultar páginas inactivas correctamente */
ion-router-outlet .ion-page-invisible,
ion-router-outlet .ion-page.ion-page-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Forzar que las páginas activas estén al frente */
ion-router-outlet .ion-page:not(.ion-page-hidden) {
  z-index: 100 !important;
}

/* Forzar GPU compositing para mejor rendimiento de repaint en iOS */
ion-router-outlet .ion-page {
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

</style>

<style scoped>
.fullscreen-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: var(--ion-color-primary-back, #eeeeed);
  display: flex;
  justify-content: center;
  align-items: center;
}
.new-match-container {--background: var(--ion-color-bg)}
.ios ion-toolbar { --background: var(--ion-color-primary);}
.box {
  position: absolute;
  top: 40%;
  bottom: 45%;
  left: 10%;
  right: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo {
  display: flex;
  justify-content: center;
  align-items: start;
  height: 100%;
}
.logo-native{
  margin-top: env(safe-area-inset-top, 30px);
}
.hide-tabs ion-tab-bar {
  display: none;
}


/* ============================================
   NUEVO TAB BAR - DISEÑO CON CÍRCULOS CREMA
   ============================================ */

ion-tab-bar {
  position: fixed !important;
  bottom: calc(8px + env(safe-area-inset-bottom, 34px)) !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: 92% !important;
  max-width: 380px !important;

  height: 56px !important;
  min-height: 56px !important;
  max-height: 56px !important;
  border-radius: 12px !important;

  /* Fondo negro */
  background: #000000 !important;
  background-color: #000000 !important;

  box-shadow: 0 8px 24px rgba(0,0,0,0.4) !important;

  display: flex !important;
  justify-content: space-around !important;
  align-items: center !important;
  padding: 0 12px !important;

  border: none !important;
  --border: none !important;

  overflow: visible !important;
  contain: none !important;
}

ion-tab-button {
  --color: #F8E9BF;
  --color-selected: #F8E9BF;
  position: relative;
  background-color: transparent !important;
  height: 100% !important;
  max-height: 56px !important;
  padding: 4px 0 !important;
  flex: 1;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 1;
}

/* Resetear cualquier pseudo-elemento del diseño antiguo */
ion-tab-button::before,
ion-tab-button::after,
ion-tab-button.tab-selected::before,
ion-tab-button.tab-selected::after {
  content: none !important;
  display: none !important;
}

/* Ocultar iconos por defecto de Ionic */
ion-tab-button ion-icon,
ion-tab-button svg:not(.tab-icon-circle svg):not(.svg-inline--fa) {
  display: none !important;
}

/* Círculo crema alrededor del icono */
.tab-icon-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #F8E9BF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2px;
  transition: all 0.2s ease;
}

/* Los iconos SVG dentro del círculo - verde por defecto */
.tab-icon-circle svg {
  width: 24px !important;
  height: 24px !important;
}

.tab-icon-circle svg path {
  fill: #5A695B !important;
  transition: fill 0.2s ease;
}

/* Icono FontAwesome dentro del círculo - verde por defecto */
.tab-icon-circle .svg-inline--fa {
  width: 20px !important;
  height: 20px !important;
  color: #5A695B !important;
  transition: color 0.2s ease;
}

/* Etiquetas debajo del icono - color crema */
ion-tab-button ion-label {
  font-size: 0.6rem !important;
  font-weight: 600 !important;
  color: #F8E9BF !important;
  margin-top: 0 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.3px !important;
  transition: all 0.2s ease !important;
  white-space: nowrap !important;
}

/* Tab seleccionado - iconos rosa */
ion-tab-button.tab-selected .tab-icon-circle svg path {
  fill: #FF5287 !important;
}

ion-tab-button.tab-selected .tab-icon-circle .svg-inline--fa {
  color: #FF5287 !important;
}

ion-tab-button.tab-selected ion-label {
  color: #F8E9BF !important;
}

/* Ocultar badges */
ion-badge {
  display: none !important;
}

.loading{
    align-items: center;
    justify-items: center;
    display: flex;
    flex-direction: column;
}
.overlay-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: linear-gradient(to bottom, var(--ion-color-header), var(--ion-color-footer));;
  --background: linear-gradient(to bottom, var(--ion-color-header), var(--ion-color-footer));;
  display: flex;
  justify-content: center;
  align-items: center;
  scrollbar-width: none;
}

.notifications-box {
  width: 85%;
  max-width: 400px;
  background: var(--ion-color-primary-back, #eeeeed);
  padding: 25px;
  border-radius: 20px;
  text-align: center;
  color: #111;
}

.notifications-box .title {
  font-size: 1.4rem;
  margin-bottom: 15px;
}

.notifications-box .text {
  font-size: 1rem;
  opacity: 0.8;
  margin-bottom: 25px;
}

.btn-accept {
  width: 100%;
  background: #FF5287 !important;
  color: var(--ion-color-primary-back, #eeeeed);
  padding: 12px;
  border-radius: 12px;
  margin-bottom: 12px;
  border: none;
  font-size: 1rem;
}

.btn-later {
  width: 100%;
  padding: 10px;
  color: #FF5287 !important;
  background: var(--ion-color-primary-back, #eeeeed);
  border: 1px solid #FF5287 !important;
  border-radius: 12px;
  font-size: 0.95rem;
  margin-bottom: 12px;
}

.kiwish-alert-box {
  width: 85%;
  max-width: 430px;
  background: var(--ion-color-primary-back, #eeeeed);
  padding: 25px 25px 30px;
  border-radius: 22px;
  text-align: center;
  color: #111;
  box-shadow: 0 8px 22px rgba(0,0,0,0.2);
  animation: kiwishFadeIn 0.2s ease-out;
}

.kiwish-alert-box .title {
  font-size: 1.4rem;
  margin-bottom: 15px;
  font-weight: 600;
  color: #FF5287 !important;
}

.kiwish-alert-box .text {
  font-size: 1rem;
  opacity: 0.85;
  margin-bottom: 25px;
  line-height: 1.45;
}

/* animación suave */
@keyframes kiwishFadeIn {
  from { opacity: 0; transform: scale(0.92); }
  to { opacity: 1; transform: scale(1); }
}

/* Error fullscreen - centralizado para todos los tabs */
.error-fullscreen {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background: linear-gradient(to bottom, var(--ion-color-header), var(--ion-color-footer));
}

</style>